export default __webpack_public_path__ + "static/media/f4.2d4ffb3a.jpg";